import React from "react";

import { ToastContainer, toast } from "react-toastify";

class Toast {
  static show({
    id,
    type = "success",
    content = "",
    position = "top-right",
    autoClose = 3000,
    className = null,
    hideProgressBar = false,
    closeOnClick = true,
    pauseOnHover = true,
    draggable = true,
    progress = undefined,
    onClose = () => {},
    onClick = () => {},
  }) {
    switch (type) {
      case "success":
        return toast.success(content, {
          ...(id && { toastId: id }),
          position,
          className,
          autoClose,
          hideProgressBar,
          closeOnClick,
          pauseOnHover,
          draggable,
          progress,
          onClose,
          onClick,
        });
      case "error":
        return toast.error(content, {
          ...(id && { toastId: id }),
          position,
          className,
          autoClose,
          hideProgressBar,
          closeOnClick,
          pauseOnHover,
          draggable,
          progress,
          onClose,
          onClick,
        });
      default:
        return toast(content, {
          ...(id && { toastId: id }),
          position,
          className,
          autoClose,
          hideProgressBar,
          closeOnClick,
          pauseOnHover,
          draggable,
          progress,
          onClose,
          onClick,
        });
    }
  }

  static dismiss({ id }) {
    toast.dismiss(id);
  }
}

export default Toast;
